/* eslint-disable */
import React from 'react';

// component
import Breadcrumbs from '../../components/Breadcrumbs'
import SupportForm from '../../components/supportForm'

const support = () => {

 const breadcrumbStyle = {
    backgroundColor: 'rgb(245, 245, 245)',
    width: '98vw',
    padding: '20px 20px 10px',
    height: '45px',
  }

  const breadcrumbPath = [
    {label: 'support-tab-title'},
  ]

return (
  <>
    <div style={breadcrumbStyle}>
      <Breadcrumbs crumbs={breadcrumbPath} />
    </div>
    <SupportForm />
  </>
  )
}

export default support
